import { render, staticRenderFns } from "./createRoleType.vue?vue&type=template&id=e3c19e7e"
import script from "./createRoleType.vue?vue&type=script&lang=js"
export * from "./createRoleType.vue?vue&type=script&lang=js"
import style0 from "./createRoleType.vue?vue&type=style&index=0&id=e3c19e7e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports